import { Injectable, linkedSignal, signal } from '@angular/core';
import { DegreeLevelOption } from '@uc/web/shared/data-models';
import {
	BASIC_DEGREE_LEVEL_OPTIONS,
	CLEARING_DEGREE_LEVEL_OPTION,
} from '../static/course-degree-level.properties';
import { CLEARING_ENABLED } from '@uc/web/config';
import { ProductEnum } from '@uc/shared/data-models';

@Injectable({ providedIn: 'root' })
export class DegreeLevelService {
	private _degreeLevels = signal<DegreeLevelOption[]>(this._getDegreeLevels());
	degreeLevels = this._degreeLevels.asReadonly();

	private _selectedDegreeLevel = signal<DegreeLevelOption>(this.degreeLevels()[0]);
	selectedDegreeLevel = this._selectedDegreeLevel.asReadonly();

	// Signal to track the selected degree level specifically for clearing API queries
	selectedClearingDegreeLevel = linkedSignal({
		source: this._selectedDegreeLevel,
		computation: () => ({ ...CLEARING_DEGREE_LEVEL_OPTION }),
	});

	// Reactive signal that determines whether the Clearing API should be queried.
	shouldQueryClearingAPI = linkedSignal({
		source: () => this._selectedDegreeLevel,
		computation: () =>
			this._selectedDegreeLevel().link === ProductEnum.Clearing || false,
	});

	setDegreeLevels(degreeLevels: DegreeLevelOption[]) {
		this._degreeLevels.set(degreeLevels);
	}

	setSelectedDegreeLevel(degreeLevel: DegreeLevelOption) {
		this._selectedDegreeLevel.set(degreeLevel);
	}

	private _getDegreeLevels() {
		if (CLEARING_ENABLED) {
			return [{ ...CLEARING_DEGREE_LEVEL_OPTION }, ...BASIC_DEGREE_LEVEL_OPTIONS];
		}

		return [...BASIC_DEGREE_LEVEL_OPTIONS];
	}
}
